module.exports = __webpack_public_path__ + "static/media/N-Mall-002.f00dbabe.webp";